// assets/src/js/modules/gsap-animations.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import two_column_content from "./section_animations/two_column_content";
import crypto_slider from "./section_animations/crypto_slider";
import three_column_cards_large from "./section_animations/three_column_cards_large";
import support_carousel from "./section_animations/support_carousel";

// Register plugins
gsap.registerPlugin(ScrollTrigger);

export default function initAnimations() {
  two_column_content();
  crypto_slider();
  three_column_cards_large();
  support_carousel();

  ScrollTrigger.create({
    trigger: ".page_take_over_cta",
    start: "top top",
    end: "+=100%", // you can adjust this depending on how long you want it pinned
    pin: ".image_section",
    pinSpacing: false, // set to true if you want the page to push down instead of overlap
    scrub: false,
  });
  gsap.to(".image_section", {
    opacity: 0,
    scrollTrigger: {
      trigger: ".block_section",
      start: "top bottom",
      end: "top top",
      scrub: true,
    },
  });

  // .three_column_cards_large

  // Integrate with Lenis for smooth scrolling + GSAP
  const lenis = window.lenis; // Assuming lenis is stored on window
  if (lenis) {
    lenis.on("scroll", ScrollTrigger.update);

    // Set up a RAF loop for GSAP + Lenis
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }
}
